import { OverlayPanelModule } from 'primeng/overlaypanel';
import { MenuModule } from 'primeng/menu';
import { TableModule } from 'primeng/table';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectModule } from 'primeng/select';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { TreeModule } from 'primeng/tree';
import { SkeletonModule } from 'primeng/skeleton';

export const PRIMENG_MODULES = [
  OverlayPanelModule,
  MenuModule,
  TableModule,
  MultiSelectModule,
  SelectModule,
  OverlayPanelModule,
  TieredMenuModule,
  TreeModule,
  SkeletonModule,
];
